var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"318c402190afa2453cdd25e00ea09c966fa19d72"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
  tracesSampleRate: parseFloat(process.env.NEXT_PUBLIC_SENTRY_SAMPLING_RATE || '') || 1.0,

  // @sentry/nextjs v8+ automatically includes all necessary integrations:
  // - Page loads and route changes
  // - HTTP requests (fetch, XMLHttpRequest, GraphQL via Apollo)
  // - User interactions (clicks, form submissions)
  // - Web Vitals (LCP, FID, CLS, FCP, TTFB)
  // - Browser APIs and errors

  // Capture unhandled promise rejections
  captureUnhandledRejections: true,

  // Enhanced error context
  initialScope: {
    tags: {
      component: 'nextjs-client'
    }
  }
});
